import {actions} from '../actions';

const initialState = {};

export default function reviewMetricsReducer(state = initialState, action) {
  switch (action.type) {
    case actions.REVIEW_METRICS.FETCH_FULFILLED: {
      const {data} = action.payload;
      return {...state, ...data};
    }
  }

  return state;
}
